'use strict';

var Box = require('../../../node_modules/@material-ui/core/esm/Box/Box.js');



module.exports = Box["default"];
